<template>
  <div class="install-desc-ios">
    <a href="https://walkingcloset.network/closet" target="_blank"><img class="d-block w-100 mb-3" :src="require('@/assets/images/installDesc/ios1.png')" /></a>
    <img class="d-block w-100 mb-3" :src="require('@/assets/images/installDesc/ios2.png')"  />
    <img class="d-block w-100 mb-3" :src="require('@/assets/images/installDesc/ios3.png')"  />
    <img class="d-block w-100 mb-3" :src="require('@/assets/images/installDesc/ios4.png')"  />
  </div>
</template>


<script>

export default {
  name: 'InstallDescIOS',
  data() {
    return {
    };
  },
  props: {
    imgSrc: {
    },
  },
  components: {
  },
  computed: {
	},
  watch: {
  },
  mounted() {
	},
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.install-desc-ios {
}
</style>
